import { render } from "./Demo.vue?vue&type=template&id=47be0e55&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"

import "./Demo.vue?vue&type=style&index=0&id=47be0e55&lang=less&scoped=true"

import exportComponent from "D:\\works\\krc_notice\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47be0e55"]])

export default __exports__